module.exports = __webpack_public_path__ + "static/media/kid_avatar_05.e886d25c.png";